import script from "./AddSingleVariantModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSingleVariantModal.vue?vue&type=script&setup=true&lang=js"

import "./AddSingleVariantModal.vue?vue&type=style&index=0&id=279591f9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279591f9"]])

export default __exports__